// extracted by mini-css-extract-plugin
export var experienceSection = "experience-section-module--experienceSection--V1svb";
export var leftColumn = "experience-section-module--leftColumn--BoX1M";
export var middleColumn = "experience-section-module--middleColumn--bKE4Z";
export var rightColumn = "experience-section-module--rightColumn--Simiv";
export var title = "experience-section-module--title--6N3d1";
export var titlePart = "experience-section-module--titlePart--xXeai";
export var wrapper = "experience-section-module--wrapper--bVRuD";